import * as buttons from 'smg/buttons';
import { UpdateCurrentUser, UpdateCurrentUserPassword } from 'smg/customer-api/currentuser';
import * as session from 'smg/customer-api/session';
import { ReportValidity } from 'smg/form';
import { Phone } from 'smg/phone';

import { Relref } from '../hugo';
import { AccountReady } from '../account-session';

void main();

async function main() {
    if (await AccountReady) {
        return;
    }
    const sess = await session.Session();

    // ── Profile section ──

    const $profileForm = document.querySelector('#profile-form') as HTMLFormElement;
    const $firstName = document.querySelector('#settings-first-name') as HTMLInputElement;
    const $lastName = document.querySelector('#settings-last-name') as HTMLInputElement;
    const $company = document.querySelector('#settings-company') as HTMLInputElement;
    const $email = document.querySelector('#settings-email') as HTMLInputElement;
    const $phoneInput = document.querySelector('#settings-phone') as HTMLInputElement;

    const phone = new Phone($phoneInput);

    // Populate from session
    $firstName.value = sess.user.firstName ?? '';
    $lastName.value = sess.user.lastName ?? '';
    $company.value = sess.user.company ?? '';
    $email.value = sess.user.emailAddress.email ?? '';
    void phone.ready().then(() => phone.iti.setNumber(sess.user.phoneNumber.phone ?? ''));

    $profileForm.addEventListener('submit', async e => {
        e.preventDefault();
        if (!ReportValidity($profileForm)) {
            return;
        }

        const $fieldset = $profileForm.querySelector('fieldset') as HTMLFieldSetElement;
        const $submit = $profileForm.querySelector('[type="submit"]') as HTMLButtonElement;
        $fieldset.setAttribute('disabled', 'disabled');
        buttons.Start($submit);

        try {
            await UpdateCurrentUser({
                firstName: $firstName.value,
                lastName: $lastName.value,
                company: $company.value,
                email: $email.value,
                phone: await phone.format(),
            });
            session.ClearCache();
            showSaved($profileForm);
        } catch {
            showError($profileForm, 'Failed to save profile. Please try again.');
        } finally {
            $fieldset.removeAttribute('disabled');
            buttons.Stop($submit);
        }
    });

    // ── Password section ──

    const $passwordForm = document.querySelector('#password-form') as HTMLFormElement;
    const $newPassword = document.querySelector('#settings-new-password') as HTMLInputElement;
    const $confirmPassword = document.querySelector('#settings-confirm-password') as HTMLInputElement;

    $confirmPassword.addEventListener('input', () => {
        if ($confirmPassword.value && $confirmPassword.value !== $newPassword.value) {
            $confirmPassword.setCustomValidity('Passwords do not match');
        } else {
            $confirmPassword.setCustomValidity('');
        }
    });
    $newPassword.addEventListener('input', () => {
        if ($confirmPassword.value && $confirmPassword.value !== $newPassword.value) {
            $confirmPassword.setCustomValidity('Passwords do not match');
        } else {
            $confirmPassword.setCustomValidity('');
        }
    });

    $passwordForm.addEventListener('submit', async e => {
        e.preventDefault();
        if (!ReportValidity($passwordForm)) {
            return;
        }

        const $fieldset = $passwordForm.querySelector('fieldset') as HTMLFieldSetElement;
        const $submit = $passwordForm.querySelector('[type="submit"]') as HTMLButtonElement;
        $fieldset.setAttribute('disabled', 'disabled');
        buttons.Start($submit);

        try {
            await UpdateCurrentUserPassword({
                newPassword: $newPassword.value,
                confirmPassword: $confirmPassword.value,
            });
            $newPassword.value = '';
            $confirmPassword.value = '';
            showSaved($passwordForm);
        } catch {
            showError($passwordForm, 'Failed to update password. Please try again.');
        } finally {
            $fieldset.removeAttribute('disabled');
            buttons.Stop($submit);
        }
    });

    // ── Mobile sign out ──

    const $mobileSignOut = document.querySelector('#mobile-sign-out');
    $mobileSignOut?.addEventListener('click', () => {
        session.DeleteSession();
        window.location.href = Relref('/login');
    });

    // ── Helpers ──

    function showSaved($form: HTMLFormElement) {
        const $saved = $form.querySelector('.settings-saved') as HTMLElement;
        if (!$saved) {
            return;
        }
        $saved.classList.remove('d-none');
        setTimeout(() => $saved.classList.add('d-none'), 3000);
    }

    function showError($form: HTMLFormElement, msg: string) {
        // Remove existing alert
        $form.querySelector('.alert-danger')?.remove();

        const $alert = document.createElement('div');
        $alert.className = 'alert alert-danger alert-dismissible fade show';
        $alert.setAttribute('role', 'alert');
        $alert.innerHTML = `${msg}<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>`;

        const $body = $form.closest('.account-section-body');
        if ($body) {
            $body.insertBefore($alert, $body.firstChild);
        }
    }
}
